import { FileNameCell, StyledDropzoneFileRow, StyledMoreVert, TimeSinceUploadCell, } from './StylovyzeDropzone.styles';
import Check from '@mui/icons-material/Check';
import DeleteFile from './icons/DeleteFile';
import FilePaper from './icons/FilePaper';
import MenuListButton from '@innovyze/stylovyze/lib/components/MenuListButton';
import React from 'react';
import { TableCell } from '@mui/material';
import { DateTime } from 'luxon';
import { useGlobalization } from '@innovyze/stylovyze/lib/contexts/GlobalizationProvider';
import { useSettings } from '@innovyze/stylovyze/lib/contexts/Settings';
export const StylovyzeDropzoneRow = (props) => {
    const { t } = useGlobalization();
    const { companySettings } = useSettings();
    const locale = companySettings?.language.slice(0, 2) || 'en';
    const timeAgo = DateTime.fromMillis(
    // dateCreated is declared as a number but at runtime strings are passed
    new Date(props.file.dateCreated).getTime(), {
        locale: locale,
    }).toRelative();
    const menuItems = [];
    const createMenu = () => {
        if (menuItems.length)
            return (React.createElement(TableCell, null,
                React.createElement(StyledMoreVert, null,
                    React.createElement(MenuListButton, { menuItems: menuItems }))));
        return null;
    };
    if (props.onDownloadClick)
        menuItems.push({
            text: t('Download', { context: 'File dropzone menu' }),
            icon: React.createElement(Check, null),
            onClick: props.onDownloadClick,
        });
    if (props.onDeleteClick)
        menuItems.push({
            text: t('Delete', { context: 'File dropzone menu' }),
            icon: React.createElement(DeleteFile, null),
            onClick: props.onDeleteClick,
        });
    return (React.createElement(StyledDropzoneFileRow, null,
        React.createElement(TableCell, { padding: "checkbox" },
            React.createElement(FilePaper, null)),
        React.createElement(FileNameCell, { padding: "none" }, props.file.path),
        React.createElement(TimeSinceUploadCell, null, timeAgo),
        createMenu()));
};
export default StylovyzeDropzoneRow;
